/**
 * 미드텀 첫 입주 가능일의 입력 하한(BR-04). 로컬 BE 후보의 실제 wire 기준:
 * - 전환 preview의 earliest_date(YYYY-MM-DD)가 하한이다. 계약 종료 뒤 준비 영업일이 모두 지난 다음 날이며 그 날짜 자체는 허용한다.
 * - earliest_date가 null이면: eligible=true·pending=false이고 계약 상태가 확인된 경우는 준비 하한이 없는 것이고,
 *   UNKNOWN·UNBOUND·eligible=false는 확인하지 못한 것이다. 어느 경우에도 current_end 등으로 하한을 직접 계산하지 않는다 —
 *   준비 기간·달력은 서버 설정이라, 모를 때는 서버가 거절(409 준비 전·503 미확인·403 권한)하는 결과를 그대로 보여 준다.
 */
export interface FirstDateBoundSource {
  earliest_date: string | null;
  eligible: boolean;
  pending: boolean;
  contract_status: string;
}
export type FirstDateBound =
  | { kind: 'earliest'; date: string }
  | { kind: 'none' }
  | { kind: 'unknown' };

export function firstDateBound(source: FirstDateBoundSource): FirstDateBound {
  if (source.earliest_date) return { kind: 'earliest', date: source.earliest_date };
  if (
    source.eligible &&
    !source.pending &&
    source.contract_status !== 'UNKNOWN' &&
    source.contract_status !== 'UNBOUND'
  )
    return { kind: 'none' };
  return { kind: 'unknown' };
}

/** 하한이 알려져 있고 선택한 날짜가 그보다 이르면 true. 같은 날은 허용한다. 없음·미확인은 FE가 막지 않는다. */
export const beforeFirstDateBound = (bound: FirstDateBound, date: string) =>
  bound.kind === 'earliest' && date < bound.date;

/** 사용자에게 보이는 안내 — 기간(영업일 수)은 서버 설정이라 숫자를 적지 않는다. */
export function firstDateBoundMessage(bound: FirstDateBound): string {
  if (bound.kind === 'earliest')
    return `계약 종료 뒤 준비 영업일이 모두 지난 ${bound.date}부터 선택할 수 있습니다.`;
  if (bound.kind === 'none')
    return '확인된 계약이 없어 계약 준비 기간에 따른 가장 이른 날짜 제한은 없습니다.';
  return '선택할 수 있는 가장 이른 날을 확인하지 못했습니다. 서버가 계약 준비 기간을 확인해 거절할 수 있습니다.';
}
